/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
 $( document ).ready(function() {
  // Handler for .ready() called.
$( "button.slideshow__button-label " ).hover(function() {
  $( this ).click();
 
});  
   }); 